import React from "react";
import Moment from "react-moment";
import { RiPencilFill } from "react-icons/ri";
import { FiTrash } from "react-icons/fi";

import { Box, CardAtis, Content, FormCard } from "../../styles-components/Card";
import { ButtonA } from "../../styles-components/Buttons";

const ItemCard = ({
  date,
  description,
  isRowStyle,
  handleShowFormEdit,
  onDelete,
  children,
}) => {
  return (
    <CardAtis isRowStyle={isRowStyle}>
      <Box isRowStyle={isRowStyle}>
        <Content isRowStyle={isRowStyle}>
          <h3>
            <Moment format="DD/MM/YYYY">{date}</Moment>
          </h3>
          <p>{description.substr(0, 50)}</p>
          <div>
            <ButtonA
              color="--white"
              backgroundColor="--light-blue"
              onClick={handleShowFormEdit}
            >
              <RiPencilFill size={20} />
            </ButtonA>
            <ButtonA
              color="--white"
              backgroundColor="--light-blue"
              onClick={onDelete}
            >
              <FiTrash size={20} />
            </ButtonA>
          </div>
          <FormCard>{children}</FormCard>
        </Content>
      </Box>
    </CardAtis>
  );
};

export default ItemCard;
